import { datadogLogs } from '@datadog/browser-logs';

// Canonical IDs per the Snappt observability standard — attach when available.
// income_verification_review_id is non-canonical but useful for this feature.
export type NriSignalContext = {
  applicant_id?: string;
  entry_id?: string;
  submission_id?: string;
  identity_id?: string;
  company_id?: string;
  property_id?: string;
  document_id?: string;
  income_verification_review_id?: string;
};

const NRI_CHECKBOX_TOGGLED_EVENT = 'iv_nri_checkbox_toggled';
const BASE_PAY_ENTERED_EVENT = 'iv_base_pay_entered';

export const logNriCheckboxToggled = (isChecked: boolean, ctx: NriSignalContext): void => {
  datadogLogs.logger.info(NRI_CHECKBOX_TOGGLED_EVENT, {
    ...ctx,
    is_checked: isChecked
  });
};

export const logBasePayEntered = (basePayAmount: string, ctx: NriSignalContext): void => {
  const parsed = parseFloat((basePayAmount ?? '').replace(/[$,]/g, ''));
  if (!isFinite(parsed) || parsed <= 0) return;
  datadogLogs.logger.info(BASE_PAY_ENTERED_EVENT, ctx);
};
